import { render, staticRenderFns } from "./ExhibitionOpening.vue?vue&type=template&id=6defc098&"
import script from "./ExhibitionOpening.vue?vue&type=script&lang=js&"
export * from "./ExhibitionOpening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports